import React from "react";
import CargoSpecsComponent from "./cargo-specs.component";

const CargoSpecsContainer = () => {
  return <CargoSpecsComponent />;
};

export default CargoSpecsContainer;
